<template>
  <b-modal
    id="create-customer-payment-intent"
    :title="$t('Create Customer Payment Intent')"
    hide-footer
    @show="onShow"
  >
    <validation-observer ref="paymentForm" v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(createCustomerPaymentIntent)">
        <b-form-group :label="$t('Amount')" label-for="amount">
          <validation-provider #default="{ errors }" :name="$t('Amount')" rules="required">
            <b-input-group>
              <b-form-input id="amount" step="0.01" v-model="amount" type="number" required />
              <b-input-group-append>
                <b-input-group-text>TRY</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <div class="d-flex justify-content-end gap-1">
          <b-button type="button" class="mr-1" variant="secondary" @click="onHide">{{
            $t('Cancel')
          }}</b-button>
          <b-button type="submit" :loading="loading" :disabled="loading" variant="primary">{{
            $t('Create')
          }}</b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupText
} from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import useService from '@/auth/service/useService';
import { helper } from '@core/mixins/helper';

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupText
  },
  mixins: [helper],
  props: {
    customerId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      amount: null,
      loading: false
    };
  },
  methods: {
    onHide() {
      this.$bvModal.hide('create-customer-payment-intent');
    },
    onShow() {
      this.amount = null;
    },
    createCustomerPaymentIntent() {
      this.loading = true;
      useService.paymentService
        .createPaymentIntent({
          customer_id: this.customerId,
          amount: this.amount,
          currency: 'TRY'
        })
        .then(() => {
          this.onHide();
          this.showSuccessMessage(this.$t('Payment intent created successfully!'));
        })
        .catch(() => {
          this.showErrorMessage(this.$t('Payment intent creation failed!'));
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
